<template lang="pug">
include TrainerViewCategoriasRegistro.pug
</template>

<script type="text/javascript">
import { filter, isEmpty, isArray } from "underscore"
import TrainerTitle from '@/components/trainer_title/TrainerTitle'

export default {
  name: "TrainerViewCategoriasRegistro",
  components: {
    TrainerTitle
  },
  props: ["trainer", "plan"],
  computed: {
    version: function() {
      const trainer = this.trainer
      if (trainer.courses_v2.length) return 2
      return 1
    },
    hasLevel: function() {
      const version = this.version
      let hasLevel = false
      let courses = []
      if (version === 1) {
        // V1
        courses = this.trainer.courses
        courses.forEach(item => {
          if (item.level) hasLevel = true
        })
      } else {
        // V2
        courses = this.trainer.courses_v2
        courses.forEach(item => {
          if (item.level) hasLevel = true
        })
      }

      return hasLevel
    },
    onlyCecs: function() {
      const onlyCecsLegacy =
        filter(this.trainer.courses, item => {
          return !isEmpty(item.level_course_title)
        }).length == 0
      const coursesV2 = this.trainer.courses_v2
      let hasV2Level = false
      if (isArray(coursesV2) && !isEmpty(coursesV2)) {
        for (const item of coursesV2) {
          if (!isEmpty(item.level)) hasV2Level = true
        }
      }
      return onlyCecsLegacy && !hasV2Level
    },
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
@import './../variables';
@import '../variables_colreps';
@import '../variables_mexreps';

@import './TrainerViewCategoriasRegistro';
</style>



// WEBPACK FOOTER //
// src/components/TrainerViewCategoriasRegistro.vue